<template>
  <div id="app">
    <router-view v-if="isRouterAlive"></router-view>
    <DemoAlert />
  </div>
</template>

<script>
import Bus from "utils/bus.js";
export default {
  name: "app",
  components: {},
  provide() {
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,
      // isforecast: true
    };
  },
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" rel="stylesheet/less">
/* ponytail: min-width 已移除，改用内容自适应 + overflow:auto。
   如果特定页面确实需要宽屏布局，在页面级用 min-width 控制，
   不要锁死整个 App。 */
#app {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: auto;
  font-family: "opposans";
}
@font-face {
  font-family: "Alternate";
  src: url("./assets/iconfont/Alternate.ttf");
  font-display: swap;
}
@font-face {
  font-family: "opposans";
  src: url("./assets/iconfont/OPPOSans-M.ttf");
  font-display: swap;
}
@font-face {
  font-family: "PangMenZhengDaoBiaoTiTi-1";
  src: url("./assets/iconfont/PangMenZhengDaoBiaoTiTi-1.ttf");
  font-display: block;
}

.el-menu.el-menu--horizontal {
  border-bottom: none !important;
}
</style>
